import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Container = styled.div``;

export const CustomerTenantContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #f3f4f7;
  padding: 16px;

  .customer-name {
    color: #8d929e;

    font-weight: 400;
    font-size: 12px;
    font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'apple color emoji',
      'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
  }
`;

export const ValueContainer = styled.div`
  padding: 24px 0px 0px 0px;
  margin-bottom: 32px;
`;

export const ValueText = styled.h2<{ isDeposit: boolean | null }>`
  color: ${({ isDeposit }) => (isDeposit ? COLORS.autonomy : '#000')};
`;

export const RechargeContainer = styled.div`
  display: flex;
  flex-direction: column;

  .charge-box,
  .external-payment-reference,
  .error-message,
  .external-id-array {
    color: #000;
    font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'apple color emoji',
      'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
  }

  .recharge-id {
    color: ${({ theme }) => theme.primary};
    margin-top: 4px;
  }
`;

export const MoreDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 24px;
`;

export const Title = styled.h4<{ isFirstItem?: boolean }>`
  margin-top: ${({ isFirstItem }) => (isFirstItem ? '0px' : '16px')};
  border-bottom: 1px solid #d1d5db;
  margin: 0 -16px;
  padding: 0 16px 8px;
`;

export const Subtitle = styled.p`
  display: flex;
  color: #8d929e;
  margin-bottom: 8px;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'apple color emoji', 'segoe ui emoji',
    'Segoe UI Symbol', 'noto color emoji';
  border-bottom: 1px solid #f3f4f6;
  padding: 8px 0;
  justify-content: space-between;
`;

export const Value = styled.p`
  color: #000;
  margin: 0px;
  margin-left: 8px;
  font-size: 12px;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'apple color emoji', 'segoe ui emoji',
    'Segoe UI Symbol', 'noto color emoji';
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: right;
`;

export const lastLine = {
  borderBottom: 'none',
  marginBottom: 0,
};

export const StrongValue = styled(Value)`
  font-weight: 600;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
